export default {"src":"/_next/static/media/overheadEquipmentLabels.0f12ab21.svg","height":720,"width":1080,"blurWidth":0,"blurHeight":0};